var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1z",
    fill: "#C9A87A",
    fillOpacity: 0.16,
    stroke: "url(#7p2998kx8a)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1z",
    fill: "#C9A87A",
    fillOpacity: 0.16,
    stroke: "url(#a8pdb1pw4b)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3a5 5 0 0 0-5 5v9a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H7zm1 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8A4.5 4.5 0 0 1 7 3.5v-1A5.5 5.5 0 0 0 1.5 8h1zm0 9V8h-1v9h1zM7 21.5A4.5 4.5 0 0 1 2.5 17h-1A5.5 5.5 0 0 0 7 22.5v-1zm10 0H7v1h10v-1zm4.5-4.5a4.5 4.5 0 0 1-4.5 4.5v1a5.5 5.5 0 0 0 5.5-5.5h-1zm0-9v9h1V8h-1zM17 3.5A4.5 4.5 0 0 1 21.5 8h1A5.5 5.5 0 0 0 17 2.5v1zm-10 0h10v-1H7v1zm2 8A1.5 1.5 0 0 0 7.5 13h1a.5.5 0 0 1 .5-.5v-1zm6 0H9v1h6v-1zm1.5 1.5a1.5 1.5 0 0 0-1.5-1.5v1a.5.5 0 0 1 .5.5h1zM15 14.5a1.5 1.5 0 0 0 1.5-1.5h-1a.5.5 0 0 1-.5.5v1zm-6 0h6v-1H9v1zM7.5 13A1.5 1.5 0 0 0 9 14.5v-1a.5.5 0 0 1-.5-.5h-1z",
    fill: "url(#dl8skdwsuc)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7p2998kx8a",
    x1: 8.484,
    y1: 9.679,
    x2: 6.189,
    y2: 9.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a8pdb1pw4b",
    x1: 16.484,
    y1: 9.679,
    x2: 14.189,
    y2: 9.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl8skdwsuc",
    x1: 16.84,
    y1: 32.179,
    x2: -3.257,
    y2: 23.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateCalendar);
export default __webpack_public_path__ + "static/media/corporateCalendar.3c001211711885d470cf1948a3ebe3ca.svg";
export { ForwardRef as ReactComponent };